import { DateUtils, RangeModifier } from 'react-day-picker';

const isDayInMoveInWindow = (moveInWindows: RangeModifier[], day: Date) =>
  moveInWindows.some(({ from, to }) =>
    DateUtils.isDayInRange(day, { from: new Date(from), to: new Date(to) }),
  );

export default isDayInMoveInWindow;
